import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import FloatingCodeSnippets, { type FloatingSnippet } from "./FloatingCodeSnippets";
import { siteContent } from "../content/site";
import "./WorkSection.css";

const WORK_SNIPPETS: FloatingSnippet[] = [
  {
    id: "work-reminder",
    code: "queue.add(\n  \"job-reminder\"\n)",
    position: { x: "93%", y: "15%" },
    rotate: -5,
    delay: 0,
    color: "#9e4d2e",
  },
  {
    id: "work-jobs",
    code: "await api.get(\n  \"/jobs\"\n)",
    position: { x: "7%", y: "50%" },
    rotate: -4,
    delay: 0.18,
    color: "#8d6c55",
  },
  {
    id: "work-docker",
    code: "docker compose\nup -d",
    position: { x: "93%", y: "86%" },
    rotate: 3,
    delay: 0.32,
    color: "#c88d57",
  },
  {
    id: "work-query",
    code: "SELECT * FROM\njobs;",
    position: { x: "7%", y: "15%" },
    rotate: 5,
    delay: 0.35,
    color: "#ef6b4a",
  },
  {
    id: "work-checkout",
    code: "stripe.checkout\n.sessions.create()",
    position: { x: "93%", y: "50%" },
    rotate: -4,
    delay: 0.52,
    color: "#b56d46",
  },
  {
    id: "work-worker",
    code: "worker.process(\n  \"job-reminder\"\n)",
    position: { x: "7%", y: "86%" },
    rotate: 4,
    delay: 0.68,
    color: "#d3a873",
  },
];

const WorkSection: React.FC = () => {
  const { work } = siteContent;

  return (
    <section className="work-section" id={work.sectionId}>
      <div className="work-section__background" aria-hidden="true">
        <div className="work-section__fade work-section__fade--top" />
        <div className="work-section__fade work-section__fade--bottom" />
        <div className="work-section__glow" />
      </div>
      <FloatingCodeSnippets
        snippets={WORK_SNIPPETS}
        className="floating-code-snippets--overflow-visible work-section__snippets"
        interactive
      />
      <div className="section-shell work-section__shell">
        <div className="work-section__projects">
          {work.projects.map((project) => (
            <div key={project.title} className="work-section__project-shell">
              <div className="work-section__project-card">
                <div className="work-section__header">
                  <p className="work-section__eyebrow">Featured</p>
                  <h3 className="work-section__title">{project.title}</h3>
                  <p className="section-copy work-section__description">{project.description}</p>
                </div>

                <div className="work-section__media-column">
                  <div className="work-section__image-frame">
                    <img
                      src={project.image}
                      alt={project.imageAlt}
                      className="work-section__image"
                    />
                  </div>
                </div>

                <ul className="work-section__stack">
                  {project.stack.map((item) => (
                    <li key={item} className="work-section__stack-item">
                      {item}
                    </li>
                  ))}
                </ul>

                <ul className="work-section__feature-list">
                  {project.features.map((feature) => (
                    <li key={feature} className="work-section__feature-item">
                      <span className="work-section__feature-dot" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="work-section__actions">
                  <a
                    href={project.liveDemo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button-primary work-section__action-link"
                  >
                    <FaExternalLinkAlt />
                    View Project
                  </a>

                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button-secondary work-section__secondary-link"
                  >
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
